import { axios } from '@/services/axios';

const updatePlatformUserAttributes = async ({
    formData,
    scope,
    platformUserId,
}) => {
    console.log(
        'updatePlatformUserAttributes',
        formData,
        scope,
        platformUserId,
    );
    const res = await axios.put(
        `/PlatformUser/${platformUserId}/Attributes`,
        formData,
        {
            headers: {
                'Content-Type': 'application/json',
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};

export default updatePlatformUserAttributes;
